import { supabase } from '@/integrations/supabase/client';

export async function seedTestData() {
  try {
    // Criar empresa de teste
    const { data: empresaData, error: empresaError } = await supabase
      .from('empresas')
      .insert({
        nome: 'Tech Solutions LTDA',
        produto: 'Software de gestão empresarial completo com módulos de vendas, estoque e financeiro',
        publico: 'Pequenas e médias empresas que buscam automatizar processos',
        proposta_valor: 'Redução de 70% no tempo de processos manuais com interface intuitiva e suporte 24/7',
        plano: 'expert',
        feedbacks: 100
      })
      .select()
      .single();

    if (empresaError) {
      console.error('Erro ao criar empresa:', empresaError);
      return { success: false, error: empresaError };
    }

    console.log('Empresa criada:', empresaData);

    // Criar usuários de teste
    const usuarios = [
      {
        id: crypto.randomUUID(),
        nome: 'Admin Silva',
        email: 'admin@test.com',
        papel: 'admin' as const,
        empresa_id: null,
        creditos: 1000
      },
      {
        id: crypto.randomUUID(),
        nome: 'João Coordenador',
        email: 'coordenador@test.com',
        papel: 'coordenador' as const,
        empresa_id: empresaData.id,
        creditos: 500
      },
      {
        id: crypto.randomUUID(),
        nome: 'Maria Vendedora',
        email: 'vendedor@test.com',
        papel: 'vendedor' as const,
        empresa_id: empresaData.id,
        creditos: 100
      }
    ];

    const { data: usuariosData, error: usuariosError } = await supabase
      .from('usuarios')
      .insert(usuarios)
      .select();

    if (usuariosError) {
      console.error('Erro ao criar usuários:', usuariosError);
      return { success: false, error: usuariosError };
    }

    console.log('Usuários criados:', usuariosData);

    return { 
      success: true, 
      data: { 
        empresa: empresaData, 
        usuarios: usuariosData 
      } 
    };
  } catch (error) {
    console.error('Erro no seed:', error);
    return { success: false, error };
  }
}
